import axios from '../plugins/axios'

export default {
  data: {
    loading: false,
    success: false,
    messageType: 'error',
  },
  methods: {
    remove_plugin () {
      if (this.loading) {
        return
      }

      this.submit()
    },

    submit () {
      const formData = new FormData(this.$el)

      this.loading = true
      this.errors.clear()

      axios.post('', formData)
        .then(response => {
          location.reload()
        })
        .catch(error => {
          this.loading = false
        })
    },
  },
}


// WEBPACK FOOTER //
// ./src/controllers/remove_plugin.js